import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { getModalParams, ModalContent, useModalTitle } from '@topconagriculture/modal';
import NotificationModalContent from './NotificationModalContent';
const useStyles = makeStyles({
    root: {
        width: 900,
    },
    modalContent: {
        overflow: 'hidden',
        width: 1200,
        display: 'flex',
    },
});
export const NotificationModal = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const modalParams = useSelector(getModalParams);
    useModalTitle(t('common:platform_notifications.notifications'));
    return (React.createElement(ModalContent, { className: classes.modalContent },
        React.createElement(NotificationModalContent, { config: modalParams.config, userLocale: modalParams.userLocale, notificationId: modalParams.id, activeIndexList: modalParams.activeIndexList })));
};
export default NotificationModal;
//# sourceMappingURL=NotificationModal.js.map